import { useTheme } from "styled-components";
import HeadingAndLinks from "./headingAndLinks";
import {footerPricesCalculatorsLinks} from "helpers/links-builders/footerLinks";

const PricesCalcolators = () => {
  const { translations, locale } = useTheme();
  return (
    <HeadingAndLinks
      parentComponent={"PricesAndCalculator"}
      isMultiCol={false}
      headerText={translations.footer.pricesCalculators}
      LinksData={footerPricesCalculatorsLinks( translations, locale)}
    />
  );
};

export default PricesCalcolators;
